const months = Array(12).fill(0);
const yearStartToCurrent = Array(18).fill(2022);
const dayOfMonths = Array(31).fill(0);

const getPostNum = (num) => {
    if (num.includes("?") || num.includes("*")) return "";
    return num;
}

const byCodes = (arr, codes) =>
    codes.map(code => arr.find(x => x.postCode === code)).filter(Boolean);

const byAPrefix = (arr, max, pre = "A") => {
    const pick = arr.filter(x => {
        if (x.postCode === pre) return true; // include base A
        if (!x.postCode.startsWith(pre)) return false; // exclude non-A
        const n = parseInt(x.postCode.slice(1), 10);
        return Number.isInteger(n) && n >= 2 && n <= max;
    });
    return pick.sort((a, b) => {
        const va = a.postCode === pre ? 0 : parseInt(a.postCode.slice(1), 10);
        const vb = b.postCode === pre ? 0 : parseInt(b.postCode.slice(1), 10);
        return va - vb;
    });
};


export {
    months,
    yearStartToCurrent,
    dayOfMonths,
    getPostNum,
    byCodes,
    byAPrefix
};